import * as React from 'react'

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '~/client/src/shared/components/shadcn-ui/empty'

export type AuthStatusTone = 'neutral' | 'success' | 'destructive'

const MEDIA_CLASS_NAMES: Record<AuthStatusTone, string | undefined> = {
  neutral: undefined,
  success: 'tw:bg-success/10 tw:text-success',
  destructive: 'tw:bg-destructive/10 tw:text-destructive',
}

interface IProps {
  icon: React.ReactNode
  tone?: AuthStatusTone
  title?: React.ReactNode
  description: React.ReactNode
  isLive?: boolean
  children?: React.ReactNode
}

export function AuthStatus({
  icon,
  tone = 'neutral',
  title,
  description,
  isLive,
  children,
}: IProps) {
  return (
    <Empty className="tw:p-0">
      <EmptyHeader role={isLive ? 'status' : undefined}>
        <EmptyMedia variant="icon" className={MEDIA_CLASS_NAMES[tone]}>
          {icon}
        </EmptyMedia>
        {title && (
          <EmptyTitle role="heading" aria-level={1}>
            {title}
          </EmptyTitle>
        )}
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {children && <EmptyContent>{children}</EmptyContent>}
    </Empty>
  )
}
